'use strict';

var storage = require('./storage');
var ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;
var STORAGE_KEY = 'finn_dist_is_matched';

exports.notMatchedYet = function notMatchedYet() {
    if (!storage) {
        return true;
    }

    try {
        var timestamp = storage.getItem(STORAGE_KEY);
        if (timestamp && timestamp > Date.now()) {
            return false;
        }
    } catch (e) {}
    return true;
};

exports.setMatched = function setMatched() {
    var ttl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ONE_DAY_IN_MS;

    if (!storage) {
        return;
    }

    try {
        storage.setItem(STORAGE_KEY, Date.now() + ttl);
    } catch (e) {}
};
//# sourceMappingURL=match-state.js.map